import * as React from 'react';
import { SVGProps } from 'react';

const SvgFluVaccine = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.3 30.1 6 35.3m23.8-23.8-4 4m-10.9 4.7 3.3 3.2m.8-7.3 3.3 3.3m9.7 2.2L19.7 9.3m9.1 9.3L17.1 30.4l-5.8-.3-.3-5.8 11.7-11.8"
    />
    <path fill={props.fill} d="M26.2 7.8 29 5l5.7 5.8v5.6l-8.5-8.6z" />
  </svg>
);

export default SvgFluVaccine;
